import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { PartDetailsLayout } from '@/areas/parts/PartDetailsPage/PartDetailsLayout';
import type { PageStaticData } from '@/shared/routing';

// Keeps the side panel and the offer refresh across tabs, which declare their own access.
export const Route = createFileRoute('/_authenticated/next/parts/$partId')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // A layout's `Route.useSearch` is typed from its own `validateSearch`, not its tabs'.
    // `requiredQuantity` is the quantity the offers tab prices for (`StandardPartPricingTabs`).
    validateSearch: stringSearch({ taskId: 'optional', requiredQuantity: 'optional' }),
    component: RouteComponent,
    // The panel's state belongs to one part; the router would keep it across a param change.
    remountDeps: ({ params }) => params.partId,
});

function RouteComponent(): JSX.Element {
    const { partId } = Route.useParams();
    const taskId = Route.useSearch({ select: (search) => search.taskId });
    return (
        <PartDetailsLayout partId={partId} taskId={taskId}>
            <Outlet />
        </PartDetailsLayout>
    );
}
